import { create } from 'zustand'

/**
 * Global app state store using Zustand.
 * Manages UI state like mobile menu visibility.
 */
interface AppState {
  // Mobile navigation
  isMobileMenuOpen: boolean
  toggleMobileMenu: () => void
  closeMobileMenu: () => void

  // Navigation tracking
  currentSection: string | null
  setCurrentSection: (section: string | null) => void
}

export const useAppStore = create<AppState>((set) => ({
  isMobileMenuOpen: false,
  toggleMobileMenu: () =>
    set((state) => ({ isMobileMenuOpen: !state.isMobileMenuOpen })),
  closeMobileMenu: () => set({ isMobileMenuOpen: false }),

  currentSection: null,
  setCurrentSection: (section) => set({ currentSection: section }),
}))
